import LocalStorageService from '@/services/LocalStorageService';
import consts from '@/static/js/consts';
import store from '@/store';

const validateToken = async (token) => store.dispatch(consts.USER_ACTIONS.VALIDATE_TOKEN, {
  token,
});

const guardValidToken = async (to, from, next) => {
  const token = LocalStorageService.get('token');
  if (to.meta.protected) {
    try {
      const result = await validateToken(token);
      if (!result) {
        LocalStorageService.removeStorageFrom('token');
        next({ name: consts.ROUTES.AUTH_LOGIN.NAME });
      }
    } catch (err) {
      LocalStorageService.removeStorageFrom('token');
      next({ name: consts.ROUTES.AUTH_LOGIN.NAME });
    }
  }
};

export default {
  async autoLogin(to, from, next) {
    const token = LocalStorageService.get('token');
    if (token != null) {
      try {
        const result = await validateToken(token);
        if (result) {
          next({ name: consts.ROUTES.HOME.NAME });
        } else {
          next({ name: consts.ROUTES.HOME.NAME });
        }
      } catch (err) {
        LocalStorageService.removeStorageFrom('token');
      }
    }
    next();
  },

  async guard(to, from, next) {
    if (to.matched[0].name === consts.ROUTES.AUTH_LOGIN) {
      next();
    } else {
      await guardValidToken(to, from, next);
      next(true);
    }
  },
};
